import { Grid } from '@mui/material'
import GlobalButton from '../../Utils/GlobalUtilsComponents/GlobalButton'
import globalStyles from '../../Styles/ComponentStyles/global.module.scss'

interface ExtractDialogInterface {
    setFlagOpenExtractDataDialog?: (value: boolean) => void;
}

const ExtractDataDiallog = (props: ExtractDialogInterface) => {

    const { setFlagOpenExtractDataDialog } = props

    return (
        <Grid container>
            <Grid item xs={12}>
                {/* <iframe
                    src="https://www.retirementbrain.ai:8081/auth/1662619239061"
                    style={{ width: "100%", height: "700px" }}
                ></iframe> */}
                <iframe
                    id="tabula"
                    className="tabula_class"
                    title="Extract data"
                    src="https://www.retirementbrain.ai:8081/auth/1662619239061"
                    height={700}
                    width="100%"
                    allowFullScreen
                    style={{ width: "100%" }}
                />
            </Grid>

            <Grid item xs={12} sx={{ textAlign: "center" }}>
                <GlobalButton
                    value='Close'
                    variant='contained'
                    size='large'
                    className={`${globalStyles.globalButtonStyleV1}`}
                    onClick={() => {
                        if (setFlagOpenExtractDataDialog) {
                            setFlagOpenExtractDataDialog(false);
                        }
                    }}
                />
            </Grid>
        </Grid>
    )
}

export default ExtractDataDiallog
